module.exports = __webpack_public_path__ + "img/Sibiu_5_kl.10ee6213.jpg";